<template>
  <div>
    <audio id="audio_" ref="audio"></audio>
    <div class="audio-slider">
      <div>{{ timeRange.start }}</div>
      <van-slider
          v-model="value"
          :disabled="audioSlide"
          :max="maxNum"
          :min="minNum"
          active-color="#E7C999"
          inactive-color="#DDDDDD"
          @change="onChange"
      />
      <div>{{ timeRange.end }}</div>
    </div>
    <div class="audio-control">
      <img :class="['audio-speed',playDisbled || isDisbled?'audio-diabled':'']"
           src="@/assets/images/icon/audio_prev.png" @click.stop="playDisbled || isDisbled?'':prevAudio()"/>
      <img
          :src="playStatus?require('@/assets/images/icon/audio_end.png'):require('@/assets/images/icon/audio_start.png')"
          class="audio-start"
          @click="startPlayer"
      />

      <img :class="['audio-speed',playDisbled || isDisbled?'audio-diabled':'']"
           src="@/assets/images/icon/audio_next_detail.png" @click.stop="playDisbled || isDisbled?'':nextAudio()"/>
    </div>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import {Debounce, getCookie, is_weixin, MakeDurationToSeconds, TestUserAgent} from "@/assets/js/common.js";
import {addIntegral, inquireTime} from '@/utils/newMemberApiGlobal'

export default {
  data() {
    return {
      // 进度条起始值
      minNum: 0,
      maxNum: 1,
      // 播放状态
      playStatus: false,
      //计时器
      timer: null,
      // 计时分钟
      min: 0,
      // 计时秒
      ms: 0,
      // 当前进度值
      value: 0,
      timeRange: {
        start: "00:00",
        end: "00:00",
      },
      isTime: 0, //15 凯琪成长值 5育儿成长值
      isKq: '', //凯琪音频标识
      readingArticleDuration: 10
    };
  },
  watch: {
    audioInfo: {
      handler(newValue, oldValue) {
        //用作播放成长值判断
        if (newValue.isKq) {
          this.isKq = newValue.isKq
        } else {
          this.isKq = 'ye'
        }
        let music=document.getElementById('audio_')
        if(newValue.id!==oldValue.id){
        this.maxNum = MakeDurationToSeconds(newValue.durationStr)-0.5;
        const {audioTime} = this.$store.state.recordAudio;
        if (audioTime > 0) {
          this.$refs.audio.currentTime = audioTime;
          this.value = audioTime;
          this.min = Math.floor(audioTime / 60); //分
          this.ms = Math.floor(audioTime - this.min * 60); //秒

        } else {
          this.value = 0;
          this.min = 0;
          this.ms = 0;
        }
        this.timeRange["start"] = "00:00";
        this.$refs.audio.src = newValue.audioAddress;
        this.timeRange["end"] = newValue.durationStr;
        const {isAndroid}=TestUserAgent()
        if(isAndroid){
            music.currentTime = audioTime;
                        // this.$refs.audio.play();
        }else{
            music.addEventListener("canplay",()=>{
                music.currentTime = audioTime
            })
        }
         this.autoplayAudio()
        // 赋值音频信息
         }
      },
      deep: true,
    },
    value(val) {
      this.isTime = val
      if (val == 10 && this.playStatus) {

        // this.$emit('listenLogin')
      }
    },
    isTime(value) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      //凯琪听15秒获取成长值
      if (this.isKq == 'kq') {
        if (value == this.readingArticleDuration && this.playStatus) {
          addIntegral({
            taskGroupCode: "YDWZ00002",
            crmId: userInfo?.crm_id
          }, this, '播放完成')
        }
      }
      //育儿听15秒获取成长值
      if (this.isKq == 'ye') {
        if (value == this.readingArticleDuration && this.playStatus) {
          addIntegral({
            taskGroupCode: "YDWZ00002",
            crmId: userInfo?.crm_id
          }, this, '播放完成')
        }

      }
    }
  },
  created() {
    inquireTime((data) => {
      this.readingArticleDuration = data.readingArticleDuration
    }, this)
  },
  props: {
    audioSlide: {
      type: Boolean,
      default: false
    },
    //进入详情一条数据不能切换
    playDisbled: {
      type: Boolean,
      default: false

    },
    isDisbled: {
      type: Boolean,
      default: false

    },
    audioInfo: {
      type: Object,
    },
    pages: {
      type: Object,
    }
  },
  destroyed() {
    // 页面离开时记录当前音频id 时间 分页
    const stopTime = MakeDurationToSeconds(this.timeRange["start"]);
    this.$store.commit('saveAuidoTime', {
      id: this.audioInfo.id,
      time: stopTime,
      page: this.pages.page,
      isNewAudio: this.audioInfo.only ? 1 : 0 //返回1为最新 0为列表
    })
    this.endClick();
  },
  methods: {
    setAudioTime() {
      const num = 9
      let music = document.getElementById('audio_')
      this.ms = music.currentTime = this.value = num
      this.timeRange["start"] = "00:09";

    },
    // 开始播放计时
    startPlayer() {
      const {id} = this.audioInfo
      this.playStatus = !this.playStatus;
      if (this.playStatus) {
        sessionStorage.setItem('currentPlayStatus', '1')
        this.$refs.audio.play();
        this.$emit('addPalyNum', id)
        this.audioTime();
        this.$emit("playSensor", '开始');
      } else {
        sessionStorage.setItem('currentPlayStatus', '2')
        this.endClick();
        this.$refs.audio.pause();
        this.$emit("playSensor", '暂停');
      }
    },
    // 自动播放
    autoplayAudio() {
      let music = document.getElementById('audio_')
      if (is_weixin) {
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            music.play()
          }, false);
        } else {
          document.addEventListener("WeixinJSBridgeReady", function () {
            WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
              music.play()
            });
          }, false);
        }
      } else {
        music.play()
      }
      this.endClick();
      this.playStatus = true;
      this.audioTime();
      this.$emit("playSensor", '开始');
    },
    // 计时器
    audioTime() {
      this.timer = setInterval(() => {
        this.ms++;
        if (this.ms > 59) {
          this.min += 1;
          this.ms = 0;
        }
        this.timeRange["start"] =
            this.twoNum(this.min) + ":" + this.twoNum(this.ms);
        this.showprogerss(this.twoNum(this.min) + ":" + this.twoNum(this.ms));
      }, 1000);
    },
    // 计算音频显示进度条
    showprogerss(startime) {
      const start = MakeDurationToSeconds(startime);
      const end = MakeDurationToSeconds(this.timeRange["end"]);
      if (start === end) {
        this.timeRange["start"] = "00:00";
        this.value = 0;
        this.min = 0;
        this.ms = 0;
        this.endClick();
        this.playStatus = true;
        this.audioTime();
      } else{
        this.value = start;
      }
    },

    // 时间不足两位添加0
    twoNum(str) {
      const num = String(str);
      return num[1] ? num : "0" + num;
    },
    // 清楚计时器
    endClick() {
      clearInterval(this.timer);
    },

    // 滑动改变时候赋值
    onChange(val) {

      console.log(val);
      if (val === this.maxNum) {
        this.prevAudio();
        return;
      }
      let minutes = Math.floor(val / 60); //分
      let seconds = val - minutes * 60; //秒
      this.playStatus = true;
      this.endClick();
      this.$refs.audio.currentTime = val;
      this.$refs.audio.play();
      this.audioTime();
      this.value = val;
      this.ms = seconds;
      this.min = minutes;
    },
    //下一首
    prevAudio: Debounce(function () {
      this.$emit("sendPrevPlay", this.audioInfo.id);
      this.$store.commit('saveAuidoTime', {
        id: this.audioInfo.id,
        page: 1,
        time: 0,

      })
    }),
    // 上一首
    nextAudio: Debounce(function () {
      this.$emit("sendNextPlay", this.audioInfo.id);
      this.$store.commit('saveAuidoTime', {
        id: this.audioInfo.id,
        time: 0,
        page: 1
      })
    }),
    getCookie,
  },
  mounted() {
    let audio = this.$refs.audio;
    // 监听结束事件
    audio.addEventListener("ended", () => {


      this.nextAudio();
      this.$emit("playSensor", '暂停');


    });

  },
};
</script>
<style lang="less" scoped>
.audio-slider {
  display: flex;
  padding: 0 10px;
  align-items: center;
  height: 70px;
  margin-bottom: 5px;

  .van-slider {
    width: 80%;
    margin: 0 8px 0 13px;
  }

  /deep/ .van-slider__button {
    width: 18px;
    height: 18px;
  }


}

.audio-diabled {
  opacity: 0.5;
}

.audio-control {
  width: 150px;
  margin: 0 auto;
  display: flex;
  margin-bottom: 15px;
  justify-content: space-around;
  align-items: center;

  .audio-speed {
    width: 26px;
    height: 26px;
  }

  .audio-start {
    width: 42px;
    height: 42px;
  }
}
</style>